import styled from "styled-components";

/**
 * Faixa de download do app (design de Alertas no XD): gradiente azul claro,
 * textos brancos à esquerda e ilustração da mão com o celular à direita.
 */
export const BannerWrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  margin: 0 auto;
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  background: linear-gradient(180deg, #7dd2ec 0%, #94bcff 100%);
  box-shadow: ${({ theme }) => theme.shadows.light.small};
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    align-items: center;
    width: 80%;
    min-height: 19rem;
  }
`;

export const BannerContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(4)}
    ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex: 0 0 48%;
    padding: ${({ theme }) => theme.spacing(8)};
  }
`;

export const BannerEyebrow = styled.strong`
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const BannerTitle = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.15;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: ${({ theme }) => theme.fontSizes.xxl};
  }
`;

export const BannerText = styled.p`
  margin: 0;
  max-width: 28rem;
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  line-height: 1.4;
`;

export const BannerImage = styled.img`
  display: block;
  align-self: center;
  width: 100%;
  max-width: 18rem;
  height: auto;
  margin: -2rem 0 -3rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    position: absolute;
    right: 0;
    top: 50%;
    width: auto;
    max-width: none;
    height: 135%;
    margin: 0;
    transform: translateY(-50%);
  }
`;

/**
 * Botões das lojas de aplicativos (Google Play e App Store).
 */
export const StoreLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const StoreLink = styled.a`
  display: inline-flex;
  line-height: 0;

  & img {
    display: block;
    width: 8.5rem;
    height: auto;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.white};
    outline-offset: 3px;
  }
`;
